module.exports = __webpack_public_path__ + "static/media/home-banner.f4ad592f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jornaleiro/home-banner.png
// module id = 974
// module chunks = 0